import { Routes, Route } from 'react-router-dom';
import Login from './components/Login/Login';
import Promo from './components/Cornet/Promo';

const HOME_REDIRECT_URL = 'https://ozmo.com.tr/ozmo-adventure-land/';

function HomeRedirect() {
  window.location.replace(HOME_REDIRECT_URL);
  return null;
}

function Router() {
  return (
    <>
      <Routes> 
          <Route path='/' element={<HomeRedirect/>}/>
          <Route path='/delete' element={<Login/>}/>
          <Route path="/promo" element={<Promo />} />
      </Routes>
    </>
  );
}


export default Router;
